<template>
  <div class="task-header" :style="{ zIndex: zIndex }">
    <div class="title">{{ title }}</div>
    <div class="task-ids">
      <slot></slot>
    </div>
  </div>
</template>
<script>
/**
 * @description: 批量失败、复制的任务切换tab
 * @usage FixedItem 接收 {id: 0, filled: false} 结构
 * filled： 通过此值确定id是否被请求
 *
 * @event: [change,remove]
 */
/*  */
export default {
  props: {
    value: [Number, String],
    title: {
      type: String,
      default: '任务编号'
    },
    zIndex: {
      type: Number,
      default: 100
    },
    beforeChange: {
      type: Function
    }
  },
  computed: {
    activeTab() {
      return this.value
    }
  },
  provide: function () {
    return {
      getParent: this
    }
  },

  // updated() {
  //   console.log('this.$slots updated output: ', this.$slots)
  // },
  methods: {
    childChange(id) {
      this.$emit('input', id)
      if (id !== this.activeTab) {
        this.$emit('change', id)
      }
    },
    removeChange(id) {
      this.$emit('remove', id)
    }
  }
}
</script>
<style lang="scss" scoped>
.task-header {
  background: #fff;
  border-top: 1px solid #eee;
  width: 100%;
  padding: 24px 15px;
  position: sticky;
  left: 0;
  top: 0;
  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 4%);
  display: flex;
  justify-content: space-between;
  .title {
    font-size: 22px;
    margin-right: 20px;
    padding-left: 48px;
  }

  .task-ids {
    display: flex;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;
  }
}
</style>
